var $f5e5effd96d66274$exports = {};
const $f5e5effd96d66274$var$container = document.getElementById('grid-container');
const $f5e5effd96d66274$var$totalSquares = 300;
// Zahlen 1 bis 26 als Strings
const $f5e5effd96d66274$var$numbers = Array.from({
    length: 26
}, (_, i)=>(i + 1).toString());
// Zusätzliche Symbole
const $f5e5effd96d66274$var$symbols = [
    "\u03B1",
    "\u03B2",
    "\u03B3",
    "\u03B4",
    "\u03B5",
    "\u03B6",
    "\u03B7",
    "\u03B8",
    "\u03B9",
    "\u03BA",
    "\u03BB",
    "\u03BC",
    "\u03BD",
    "\u03BE",
    "\u03BF",
    "\u03C0",
    "\u03C1",
    "\u03C3",
    "\u03C4",
    "\u03C5",
    "\u03C6",
    "\u03C7",
    "\u03C8",
    "\u03C9",
    "#",
    "$",
    "%",
    "&"
];
// Füge die Zahlen 1 bis 26 hinzu, danach fülle den Rest mit Symbolen
const $f5e5effd96d66274$var$allSymbols = [
    ...$f5e5effd96d66274$var$numbers
];
// Fülle die restlichen Quadrate mit zufälligen Symbolen, bis wir 300 Quadrate haben
while($f5e5effd96d66274$var$allSymbols.length < $f5e5effd96d66274$var$totalSquares){
    const randomSymbol = $f5e5effd96d66274$var$symbols[Math.floor(Math.random() * $f5e5effd96d66274$var$symbols.length)];
    $f5e5effd96d66274$var$allSymbols.push(randomSymbol);
}
// Funktion zum Mischen der Quadrate
function $f5e5effd96d66274$var$shuffle(array) {
    for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [
            array[j],
            array[i]
        ];
    }
}
// Mische die Reihenfolge der Symbole
$f5e5effd96d66274$var$shuffle($f5e5effd96d66274$var$allSymbols);
// Definiere das Code-Wort
const $f5e5effd96d66274$var$codeWord = [
    15,
    16,
    1,
    12
]; // OPAL: 15 → 16 → 1 → 12
let $f5e5effd96d66274$var$currentIndex = 0; // Verfolgt die Position im Code-Wort
function $f5e5effd96d66274$var$getRandomColor() {
    // HSL-Farben für Opal-ähnliche Töne mit hohem Kontrast
    const hue = Math.random() * 360; // Zufällige Farbtöne
    return `hsl(${hue}, 70%, 50%)`; // Lebendige, kontrastreiche Farben
}
// Erstelle die Quadrate mit dynamischer Farbe
for(let i = 0; i < $f5e5effd96d66274$var$totalSquares; i++){
    const square = document.createElement('div');
    square.classList.add('square');
    square.textContent = $f5e5effd96d66274$var$allSymbols[i];
    // Setze eine passende Farbe
    square.style.setProperty('--text-color', $f5e5effd96d66274$var$getRandomColor());
    // Klick-Logik
    square.addEventListener('click', ()=>{
        const clickedValue = parseInt(square.textContent, 10);
        if (clickedValue === $f5e5effd96d66274$var$codeWord[$f5e5effd96d66274$var$currentIndex]) {
            // Richtiger Klick
            square.classList.add('visible'); // Zahl dauerhaft sichtbar machen
            $f5e5effd96d66274$var$currentIndex++;
            // Wenn das gesamte Code-Wort korrekt eingegeben wurde
            if ($f5e5effd96d66274$var$currentIndex === $f5e5effd96d66274$var$codeWord.length) window.location.href = "ardw-2025.html";
        } else {
            // Falscher Klick: Fortschritt zurücksetzen
            $f5e5effd96d66274$var$currentIndex = 0;
            // Optional: Setze die Sichtbarkeit aller Quadrate zurück
            document.querySelectorAll('.square.visible').forEach((sq)=>{
                sq.classList.remove('visible');
            });
        }
    });
    $f5e5effd96d66274$var$container.appendChild(square);
}


//# sourceMappingURL=index.c13a1013.js.map
